<script setup lang="ts">
import { ElMenu, ElMenuItem } from "element-plus";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { useIsRouteActive } from "@/composables/route";
import { useSubNav } from "./composables/menu";
import { useAuth } from "@/composables/auth";

const { t } = useI18n();
const route = useRoute();
const { subMenu } = useSubNav();
const { isSuperAdmin } = useAuth();
</script>

<template>
  <el-menu
    id="settings-nav"
    :default-active="route.name?.toString()"
    router
  >
    <h3>
      <font-awesome-icon
        class="so-icon--left"
        :icon="['fal', 'cog']"
      />
      {{ t("nav.settings") }}
    </h3>
    <h4>{{ t("nav.location") }}</h4>
    <template
      v-for="(item, index) in subMenu.group1"
      :key="index"
    >
      <el-menu-item
        :index="item.route"
        :route="{ name: item.route }"
        :class="[
          'settings-dropdown-item-heading',
          { 'is-active': useIsRouteActive(item) },
        ]"
      >
        <template #title>
          <span>{{ t(item.titleKey) }}</span>
        </template>
      </el-menu-item>
    </template>
    <hr v-if="subMenu.group2.length" />
    <h4 v-if="subMenu.group2.length">{{ t("nav.organization") }}</h4>
    <template
      v-for="(item, index) in subMenu.group2"
      :key="index"
    >
      <el-menu-item
        :index="item.route"
        :route="{ name: item.route }"
        :class="{
          'is-active': useIsRouteActive(item),
          hidden: isSuperAdmin && item.route === 'account-settings',
        }"
      >
        <template #title>
          <span>{{ t(item.titleKey) }}</span>
        </template>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<style lang="css" scoped>
h3 {
  height: 2.25rem;
  padding: 0 25px;
  margin: 20px 0;
  line-height: 2.25rem;
  color: var(--so-text-color-primary);
}

h4 {
  height: 23px;
  padding: 0 25px;
  font-size: 12px;
  color: var(--so-text-color-secondary);
  text-transform: uppercase;
}

#settings-nav {
  background-color: var(--so-color-settings-nav-bg);
  border: none;
}

#settings-nav li {
  height: 2.25rem;
  padding-right: 25px;
  padding-left: 25px;
  font-size: 0.813rem;
  line-height: 2.25rem;
  color: var(--so-text-color-primary);
  text-align: left;
}

#settings-nav > li.is-active {
  line-height: 1rem;
  word-break: break-word;
  white-space: pre-wrap;
  background-color: var(--so-bg-color);
}

#settings-nav li:hover {
  color: var(--so-color-secondary);
}

#settings-nav > li.is-active > span {
  font-weight: var(--font-bold);
}

hr {
  height: 1px;
  margin: 15px 25px;
  background-color: var(--so-border-color);
  border: 0;
}

.hidden {
  display: none;
}
</style>
